export const formatPercentage = (count: number, total: number): string =>
  total > 0 ? ((count / total) * 100).toFixed(1) : '0.0'

export const formatDuration = (durationMs: number): string => {
  if (durationMs === undefined || Number.isNaN(durationMs)) {
    return '-'
  }

  if (durationMs < 1) {
    return `${durationMs.toFixed(2)} ms`
  }

  if (durationMs < 1_000) {
    return `${durationMs.toFixed(0)} ms`
  }

  const seconds = durationMs / 1_000

  if (seconds < 60) {
    return `${seconds.toFixed(2)} s`
  }

  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  if (minutes < 60) {
    return `${minutes}m ${remainingSeconds.toFixed(0)}s`
  }

  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60

  return `${hours}h ${remainingMinutes}m`
}

/** Text color for a duration in ms, from fast (green) to slow (red) */
export const getDurationColor = (duration?: number): string => {
  if (!duration) return 'text-base-content'
  if (duration < 100) return 'text-success'
  if (duration < 500) return 'text-info'
  if (duration < 1000) return 'text-warning'
  return 'text-error'
}

export const formatDateTime = (isoDate: string): string => {
  if (!isoDate) {
    return '-'
  }

  const parsed = new Date(isoDate)

  if (Number.isNaN(parsed.getTime())) {
    return isoDate
  }

  return parsed.toLocaleString()
}

export const formatRelativeTime = (isoDate: string): string => {
  if (!isoDate) {
    return '-'
  }

  const parsed = new Date(isoDate).getTime()
  const now = Date.now()
  const deltaMs = now - parsed

  if (Number.isNaN(parsed) || Number.isNaN(deltaMs)) {
    return isoDate
  }

  const absDelta = Math.abs(deltaMs)
  const suffix = deltaMs >= 0 ? 'ago' : 'from now'

  if (absDelta < 1_000) {
    return 'just now'
  }

  if (absDelta < 60_000) {
    const seconds = Math.floor(absDelta / 1_000)
    return `${seconds}s ${suffix}`
  }

  if (absDelta < 3_600_000) {
    const minutes = Math.floor(absDelta / 60_000)
    return `${minutes}m ${suffix}`
  }

  if (absDelta < 86_400_000) {
    const hours = Math.floor(absDelta / 3_600_000)
    return `${hours}h ${suffix}`
  }

  const days = Math.floor(absDelta / 86_400_000)
  return `${days}d ${suffix}`
}
